import { ACCEPTED_UPLOAD_FORMAT_LABEL } from "@/lib/photos/constants";
import {
  validateFileSize,
  validateUploadFileType,
} from "@/lib/photos/validation";
import type { PhotoUploadResult } from "@/lib/photos/types";
import type { Photo } from "@/lib/products/types";

export const INVALID_PHOTO_FILE_MESSAGE = `Use ${ACCEPTED_UPLOAD_FORMAT_LABEL} files up to 25 MB.`;

function isUploadablePhotoFile(file: File): boolean {
  return validateUploadFileType(file).valid && validateFileSize(file).valid;
}

export function partitionPhotoFiles(fileList: FileList | File[] | null): {
  files: File[];
  hasInvalidFile: boolean;
} {
  const selectedFiles = Array.from(fileList ?? []);
  return {
    files: selectedFiles.filter(isUploadablePhotoFile),
    hasInvalidFile: selectedFiles.some((file) => !isUploadablePhotoFile(file)),
  };
}

export function previewPhotosFromResults(
  results: PhotoUploadResult[],
  previews: string[],
): Photo[] {
  return results.flatMap((result, index) => {
    const url = previews[index];
    if (url === undefined) return [];
    return [{ storageId: result.storageId, url, slot: result.slot }];
  });
}
